import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import config from '../config'

Vue.use(Vuex)

const initialState = {
  userJoinRequests: [],
  communityJoinRequests: []
}

const getters = {
  userJoinRequests: state => state.userJoinRequests,
  communityJoinRequests: state => state.communityJoinRequests
}

const mutations = {
  userJoinRequests: (state, userJoinRequests) => {
    state.userJoinRequests = userJoinRequests
  },
  communityJoinRequests: (state, communityJoinRequests) => {
    state.communityJoinRequests = communityJoinRequests
  },
  removeCommunityJoinRequest: (state, joinRequest) => {
    state.communityJoinRequests = state.communityJoinRequests.filter(item => item.id !== joinRequest.id)
  }
}

const actions = {
  async addJoinRequest ({ commit }, idCommunity) {
    let response = await axios.post(`${config.getRootApi()}/joinRequest/${idCommunity}`, null)
    commit('userJoinRequests', response.data)
  },
  resetUserJoinRequests ({ commit }) {
    commit('userJoinRequests', [])
  },
  resetCommunityJoinRequests ({ commit }) {
    commit('communityJoinRequests', [])
  },
  async fetchUserJoinRequests ({ commit }) {
    let response = await axios.get(`${config.getRootApi()}/joinRequest`)
    commit('userJoinRequests', response.data)
  },
  async fetchCommunityJoinRequests ({ commit }, idCommunity) {
    let response = await axios.get(`${config.getRootApi()}/joinRequest/${idCommunity}`)
    commit('communityJoinRequests', response.data)
  },
  async approveJoinRequest ({ commit, rootState }, joinRequest) {
    axios.put(`${config.getRootApi()}/joinRequest/approve`, joinRequest)
      .then(response => commit('removeCommunityJoinRequest', response.data))
      .then(() => {
        commit('incrementUserCount')
        commit('addMember', joinRequest.users)
      })
      .catch(error => console.error(error))
  },
  async declineJoinRequest ({ commit }, joinRequest) {
    axios.put(`${config.getRootApi()}/joinRequest/decline`, joinRequest)
      .then(response => commit('removeCommunityJoinRequest', response.data))
      .catch(error => console.error(error))
  }
}

export default {
  state: initialState,
  getters,
  mutations,
  actions
}
